import React from 'react';
import { Tile } from '@shared/types';
import TileComponent from '../tiles/TileComponent';

interface DiscardPileProps {
  topTile: Tile | null;
  canDrawDiscard: boolean;
  onDrawDiscard: () => void;
}

export const DiscardPile: React.FC<DiscardPileProps> = ({
  topTile,
  canDrawDiscard,
  onDrawDiscard,
}) => (
  <div className="discard-area">
    <span className="discard-label">ATILAN</span>
    <div
      className="discard-pile"
      data-drop-zone="discard"
      data-drop-data="discard"
      onClick={canDrawDiscard && topTile ? onDrawDiscard : undefined}
      title={canDrawDiscard && topTile ? 'Atılan taşı al' : ''}
    >
      {topTile ? (
        <TileComponent
          tile={topTile}
          
        />
      ) : (
        <div className="discard-pile-empty" />
      )}
    </div>
  </div>
);

export default DiscardPile;
